import Clear from '@/layouts/Clear.vue';

export default {
  path: '/patients',
  component: Clear,
  children: [
    {
      path: '',
      name: 'patients',
      component: () => import('@/views/Patients/PatientList.vue'),
    },
    {
      path: 'create',
      name: 'patients.create',
      component: () => import('@/views/Patients/PatientForm.vue'),
    },
    {
      path: 'patient_payment_options/:id',
      name: 'patients.payment_option_edit',
      component: () => import('@/views/Patients/PatientPaymentOptionForm.vue'),
    },
    {
      path: ':id/edit',
      name: 'patients.edit',
      component: () => import('@/views/Patients/PatientForm.vue'),
    },
    
  ],
};
